import { definedMap } from "@glideapps/ts-necessities";
import { asEnum, asString, loadedDefinedMap, loadedDefinedMapWithDefault } from "common/components/component-helpers";
import { TextBoxJustify } from "common/components/text-box-types";
import { LOADING } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { Mood } from "generator/components/mood";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import Hint from "../ui/views/hint/hint";

export const HintMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[title, text, moodValue, justifyPV]] = useForceValueProducers(getValueProducers, force, ctx);
    if (text === LOADING || title === LOADING) return env.renderProgress();

    const mood = loadedDefinedMapWithDefault(moodValue, Mood.Default, asString) as Mood;

    const justify = loadedDefinedMap(justifyPV, v => asEnum<TextBoxJustify>(v)) ?? TextBoxJustify.Left;

    return <Hint note={definedMap(text, asString)} title={definedMap(title, asString)} mood={mood} justify={justify} />;
};
